interface ISyncError {
  key: 'chatSyncErrors';
  code: 'tooManyRecords';
  message: string;
}

export function isChatSyncError(error: object): error is ISyncError {
  return 'key' in error && error.key === 'chatSyncErrors';
}
